import { wsService } from "./wsService";

import sections from "@/constants/sections";

const section = sections.SECTION_PAYSLIPS;

// param: { legajo_id, period_year, period_month, type, status }
function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function get(id) {
  return wsService.make_get_request(section + "/get/" + id);
}

// formData: file, legajo_id, period_year, period_month, period_number, type, payment_date
function upload(formData) {
  return wsService.make_post_request(section + "/upload", formData);
}

// param: { id, legajo_id }
function assign(param = {}) {
  return wsService.make_put_request(section + "/assign", param);
}

// param: { ids, scheduled_at } - sin scheduled_at publica ahora
function publish(param = {}) {
  return wsService.make_post_request(section + "/publish", param);
}

// param: { ids }
function cancel_schedule(param = {}) {
  return wsService.make_post_request(section + "/cancel-schedule", param);
}

// formData: id, reason, file (reemplazo opcional)
function void_payslip(formData) {
  return wsService.make_post_request(section + "/void", formData);
}

// param: { ids, reason }
function void_many(param = {}) {
  return wsService.make_post_request(section + "/void-many", param);
}

// Firma dibujada por el empleado -> result: { signature: data URL o null }
function signature(id) {
  return wsService.make_get_request(section + "/signature/" + id);
}

function events(id) {
  return wsService.make_get_request(section + "/events/" + id);
}

// Respuesta binaria de un PDF: { status: true, blob } o { status: false, msg }
function pdfResponse(response) {
  if (Object.prototype.toString.call(response) == "[object ArrayBuffer]") {
    const text = new TextDecoder().decode(new Uint8Array(response, 0, Math.min(response.byteLength, 5)));
    if (text == "%PDF-") {
      return { status: true, blob: new Blob([response], { type: "application/pdf" }) };
    }
    try {
      return JSON.parse(new TextDecoder().decode(response));
    } catch (e) {
      return { status: false, msg: "No se pudo abrir el archivo." };
    }
  }
  return response;
}

function file(id) {
  return wsService.make_get_request(section + "/file/" + id, { responseType: "arraybuffer" }).then(pdfResponse);
}


// Carga masiva, paso 1. formData: file, y token (archivos siguientes) o el periodo (primer archivo)
function analyze(formData) {
  return wsService.make_post_request(section + "/analyze", formData);
}

// PDF de una fila de la carga en analisis
function analyze_file(token, key) {
  return wsService.make_get_request(section + "/analyze/file/" + token + "/" + key, { responseType: "arraybuffer" }).then(pdfResponse);
}

// param: { token, key }
function analyze_ai(param = {}) {
  return wsService.make_post_request(section + "/analyze/ai", param);
}

// Carga masiva, paso 2. param: { token, key, legajo_id }
function import_line(param = {}) {
  return wsService.make_post_request(section + "/import-line", param);
}

export const payslipService = {
  section,
  filter,
  get,
  upload,
  assign,
  publish,
  cancel_schedule,
  void_payslip,
  void_many,
  events,
  signature,
  file,
  pdfResponse,
  analyze,
  analyze_file,
  analyze_ai,
  import_line,
};
